import React, { useState } from 'react';
import {
  Box, Button, Typography, TextField, Stack, Paper, Alert,
} from '@mui/material';

const defaultQuestions = [
  {
    name: 'name', label: 'Name', type: 'text', required: true,
  },
  {
    name: 'email', label: 'Email', type: 'email', required: true,
  },
  {
    name: 'budget', label: 'Budget', type: 'number', required: true,
  },
  {
    name: 'need', label: 'Need', type: 'text', required: true,
  },
  {
    name: 'timeline', label: 'Timeline (months)', type: 'number', required: true,
  },
  {
    name: 'authority', label: 'Decision Maker?', type: 'text', required: true,
  },
];

export default function LeadQualificationBotDemo() {
  const [mode, setMode] = useState('chat');
  const [form, setForm] = useState({});
  const [step, setStep] = useState(0);
  const [score, setScore] = useState(null);
  const [qualified, setQualified] = useState(false);
  const [meeting, setMeeting] = useState(null);
  const [calendarConnected, setCalendarConnected] = useState(false);
  const [alert, setAlert] = useState(null);

  // Simulate Google OAuth connect
  const handleConnectCalendar = () => {
    window.open('/api/v1/calendar/google/auth', '_blank');
    setCalendarConnected(true);
  };

  // Simulate scoring
  const handleScore = (answers) => {
    let s = 0;
    if (answers.budget && Number(answers.budget) > 1000) s += 3;
    if (answers.timeline && Number(answers.timeline) <= 3) s += 3;
    if (answers.authority && answers.authority.toLowerCase().includes('yes')) s += 2;
    if (answers.need && answers.need.length > 5) s += 2;
    setScore(s);
    setQualified(s >= 7);
    setStep('result');
  };

  // Simulate booking
  const handleBookMeeting = async () => {
    // In real app, call /api/v1/calendar/availability and /book
    setMeeting({
      summary: 'Demo Meeting',
      start: new Date().toISOString(),
      end: new Date(Date.now() + 30 * 60000).toISOString(),
    });
    setAlert({ type: 'success', msg: 'Meeting booked! (Demo)' });
  };

  return (
    <Box sx={{ maxWidth: 500, mx: 'auto', mt: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>Lead Qualification Bot Demo</Typography>
        <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
          <Button variant={mode === 'chat' ? 'contained' : 'outlined'} onClick={() => setMode('chat')}>Chat</Button>
          <Button variant={mode === 'form' ? 'contained' : 'outlined'} onClick={() => setMode('form')}>Form</Button>
        </Stack>
        {alert && <Alert severity={alert.type}>{alert.msg}</Alert>}
        {step === 0 && mode === 'form' && (
          <Box component="form" onSubmit={(e) => { e.preventDefault(); handleScore(form); }}>
            {defaultQuestions.map((q) => (
              <TextField
                key={q.name}
                label={q.label}
                type={q.type}
                required={q.required}
                fullWidth
                margin="normal"
                value={form[q.name] || ''}
                onChange={(e) => setForm((f) => ({ ...f, [q.name]: e.target.value }))}
              />
            ))}
            <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>Submit</Button>
          </Box>
        )}
        {step === 0 && mode === 'chat' && (
          <Box>
            <Typography>Chat mode coming soon (AI integration)</Typography>
            <Button
              variant="contained"
              sx={{ mt: 2 }}
              onClick={() => { setForm({
                name: 'Demo', email: 'demo@lead.com', budget: 2000, need: 'CRM', timeline: 2, authority: 'Yes',
              }); handleScore({
                name: 'Demo', email: 'demo@lead.com', budget: 2000, need: 'CRM', timeline: 2, authority: 'Yes',
              }); }}
            >
              Simulate Chat
            </Button>
          </Box>
        )}
        {step === 'result' && (
          <Box>
            <Typography variant="h6">
              Score:
              {score}
              {' '}
              / 10
            </Typography>
            {qualified ? (
              <>
                <Alert severity="success">Qualified! Offer to book a meeting.</Alert>
                {!calendarConnected && <Button variant="outlined" sx={{ mt: 2 }} onClick={handleConnectCalendar}>Connect Google Calendar</Button>}
                {calendarConnected && !meeting && <Button variant="contained" sx={{ mt: 2 }} onClick={handleBookMeeting}>Book Meeting</Button>}
                {meeting && (
                <Alert severity="success" sx={{ mt: 2 }}>
                  Meeting booked:
                  {meeting.summary}
                  {' '}
                  at
                  {meeting.start}
                </Alert>
                )}
              </>
            ) : (
              <Alert severity="info">Not qualified. Thank you!</Alert>
            )}
          </Box>
        )}
      </Paper>
    </Box>
  );
}
